<template>
  <div :style="`height:${tableHeight}px`">
    <el-table
      ref="table"
      v-loading="loading"
      :data="list"
      tooltip-effect="dark"
      style="width: 100%"
      height="100%"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="logTypeName" width="100" label="操作类型" align="center" />
      <el-table-column prop="agreementName" label="协议名称" align="center" />
      <el-table-column prop="sourceName" label="数据名称" align="center" />
      <el-table-column prop="getResultStatusName" label="状态" align="center" />
      <el-table-column prop="resultMessage" label="结果信息" align="center" />
      <el-table-column prop="createTime" width="150" label="记录时间" align="center" />
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    tableHeight: {
      type: Number,
      default: 100
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkList: []
    }
  },
  methods: {
    handleSelectionChange(e) {
      this.$emit('handleSelectionChange', e)
    },
    handleButton(emitName, item, index) {
      this.$emit(emitName, item, index)
    },
    getInstance() {
      return this.$refs.table
    }
  }
}
</script>

<style scoped lang="scss">
.checkboxList{
    display: flex;
    flex-wrap: wrap;
    .el-checkbox{
        width: 50%;
        margin-right: 0;
    }
}
.operation{
    display: inline-block;
    cursor: pointer;
}
</style>
